function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m389.81 116.26-10.152-6.095a68.19 68.19 0 0 0 1.111-12.275 68.19 68.19 0 0 0-1.111-12.275l12.36-7.421c5.905-3.545 7.818-11.206 4.272-17.111L384.616 41.64c-3.545-5.905-11.206-7.817-17.111-4.272l-12.369 7.426a67.73 67.73 0 0 0-18.368-10.412V19.97c0-6.887-5.583-12.47-12.47-12.47h-22.679c-6.887 0-12.47 5.583-12.47 12.47v14.411a67.719 67.719 0 0 0-18.368 10.412l-12.369-7.427c-5.905-3.545-13.565-1.632-17.11 4.272l-11.674 19.444c-3.545 5.905-1.633 13.565 4.272 17.111l12.36 7.421a68.19 68.19 0 0 0-1.111 12.275c0 4.192.383 8.294 1.111 12.275l-12.36 7.421c-5.905 3.545-7.817 11.206-4.272 17.111l11.674 19.444c3.545 5.905 11.206 7.817 17.111 4.272l12.369-7.427a67.715 67.715 0 0 0 18.368 10.412v14.411c0 6.887 5.583 12.47 12.47 12.47h22.679c6.887 0 12.471-5.583 12.471-12.47v-14.411a67.719 67.719 0 0 0 18.368-10.412l12.369 7.427c5.905 3.545 13.566 1.632 17.111-4.272l10.348-17.236c4.275-7.124 1.968-16.366-5.156-20.644zm-76.852 16.135c-19.057 0-34.505-15.448-34.505-34.505 0-19.057 15.448-34.505 34.505-34.505 19.057 0 34.505 15.448 34.505 34.505 0 19.056-15.448 34.505-34.505 34.505z",
    style: {},
    fill: "#7ca1b1",
    "data-original": "#7ca1b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.2 504.5h-37.59c-7.86 0-14.07-6.67-13.5-14.51l2.17-32.22 4.56-67.68-47.43 7.54c-26.37 5.08-51.3-12.56-59.91-36.16l65.2-28.75 62.52 4.44c15.29 1.09 26.5 14.82 24.49 30.02l-7.05 90.59-1.49 19.18 13.38 16.19c3.74 4.53.52 11.36-5.35 11.36z",
    style: {},
    fill: "#cb97e7",
    "data-original": "#cb97e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.55 493.14-13.38-16.19 1.49-19.18 7.05-90.59c2.01-15.2-9.2-28.93-24.49-30.02l-19.265-1.368c13.088 3.049 22.122 15.615 20.3 29.388l-8.54 111.77 13.38 16.19c3.74 4.53.52 11.36-5.35 11.36H245.2c5.87 0 9.09-6.83 5.35-11.36z",
    style: {},
    fill: "#bd80e1",
    "data-original": "#bd80e1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.688,
    cy: 170.608,
    rx: 33.413,
    ry: 33.406,
    style: {},
    transform: "rotate(-89.192 171.681 170.608)",
    fill: "#ffe5c2",
    "data-original": "#ffe5c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.206 138.58a33.244 33.244 0 0 0-21.254.748c16.305 6.093 25.336 23.862 20.302 40.801-3.099 10.427-10.835 18.205-20.286 21.76.721.27 1.452.525 2.201.748 17.685 5.258 36.283-4.819 41.54-22.508 5.257-17.689-4.818-36.291-22.503-41.549z",
    style: {},
    fill: "#fed2a4",
    "data-original": "#fed2a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.238 504.5H74.211c-8.134 0-14.728-6.594-14.728-14.728s6.594-14.728 14.728-14.728h77.027c8.134 0 14.728 6.594 14.728 14.728.001 8.134-6.593 14.728-14.728 14.728z",
    style: {},
    fill: "#a8d3d8",
    "data-original": "#a8d3d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.238 475.043h-29.033c8.134 0 14.728 6.594 14.728 14.728S130.34 504.5 122.205 504.5h29.033c8.134 0 14.728-6.594 14.728-14.728s-6.593-14.729-14.728-14.729z",
    style: {},
    fill: "#8ebac5",
    "data-original": "#8ebac5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.126 355.852h28.058v125.206h-28.058z",
    style: {},
    fill: "#7ca1b1",
    "data-original": "#7ca1b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.324 280.916c-7.049-3.68-9.78-12.378-6.1-19.427l33.831-64.8c3.68-7.049 12.378-9.78 19.427-6.1 7.049 3.68 9.78 12.378 6.1 19.427l-33.831 64.8c-3.679 7.049-12.377 9.78-19.427 6.1z",
    style: {},
    fill: "#6cf5c2",
    "data-original": "#6cf5c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.2 504.5h-37.59c-7.86 0-14.07-6.67-13.5-14.51l2.17-32.22h42.38l-1.49 19.18 13.38 16.19c3.74 4.53.52 11.36-5.35 11.36z",
    style: {},
    fill: "#7ca1b1",
    "data-original": "#7ca1b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.2 504.5h-37.59c-7.86 0-14.07-6.67-13.5-14.51l2.17-32.22h42.38l-1.49 19.18 13.38 16.19c3.74 4.53.52 11.36-5.35 11.36z",
    style: {},
    fill: "#7ca1b1",
    "data-original": "#7ca1b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.55 493.14-13.38-16.19 1.49-19.18h-23.479l-1.102 14.425a11.824 11.824 0 0 0 2.675 8.432l10.342 12.514c3.74 4.53.52 11.36-5.35 11.36H245.2c5.87-.001 9.09-6.831 5.35-11.361z",
    style: {},
    fill: "#678d98",
    "data-original": "#678d98",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.05 240.83-29.35 91.89-65.2 28.75-2.6-25.09c.4-2.63 1.03-5.26 1.9-7.88l25.39-78.16c4.62-14.23 19.51-22.42 34-18.71l35.86 9.2z",
    style: {},
    fill: "#ffe177",
    "data-original": "#ffe177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.19 231.63a28.248 28.248 0 0 0-18.107 1.372l22.595 5.797c4.296 1.102 6.78 5.592 5.43 9.817l-26.863 84.104-42.77 18.859 1.025 9.891 65.2-28.75 29.35-91.89-35.86-9.2z",
    style: {},
    fill: "#ffd15b",
    "data-original": "#ffd15b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.992 357.622h-47.71l-17.75-100.818a16.005 16.005 0 0 0-15.763-13.23c-8.84 0-16.006 7.166-16.006 16.006v121.035c0 10.161 8.237 18.399 18.399 18.399h78.831c11.43 0 20.695-9.266 20.695-20.695-.001-11.432-9.266-20.697-20.696-20.697z",
    style: {},
    fill: "#7ca1b1",
    "data-original": "#7ca1b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.992 357.622h-29.033c11.43 0 20.695 9.266 20.695 20.695 0 11.43-9.266 20.695-20.695 20.695h29.033c11.43 0 20.695-9.266 20.695-20.695 0-11.43-9.265-20.695-20.695-20.695zM56.498 256.804l15.906 90.344a12.671 12.671 0 0 0 12.479 10.474h18.398l-17.75-100.818a16.005 16.005 0 0 0-15.763-13.23c-6.435 0-11.969 3.806-14.511 9.283a15.962 15.962 0 0 1 1.241 3.947z",
    style: {},
    fill: "#678d98",
    "data-original": "#678d98",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.345 265.978 16.096 47.185c5.319 15.591 20.804 25.349 37.166 23.421l55.478-6.537c9.469-1.116 16.046-9.974 14.373-19.359-1.481-8.311-8.977-14.178-17.401-13.62l-53.605 3.553-16.019-46.958c-3.399-9.964-14.233-15.285-24.199-11.884-9.965 3.401-15.289 14.235-11.889 24.199z",
    style: {},
    fill: "#ffe177",
    "data-original": "#ffe177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.978 253.663 16.219 44.705a6.764 6.764 0 0 0 7.256 4.397l15.999-2.144-15.842-46.439c-2.976-8.723-11.624-14.46-20.76-13.248-3.577.474-6.647 1.894-9.181 3.872a18.958 18.958 0 0 1 6.309 8.857zM291.459 310.688c-1.481-8.312-8.977-14.178-17.401-13.62l-16.396 1.087c5.25 2.031 9.297 6.667 10.343 12.533 1.672 9.386-4.134 20.917-13.604 22.032l22.685-2.673c9.468-1.116 16.045-9.974 14.373-19.359z",
    style: {},
    fill: "#ffd15b",
    "data-original": "#ffd15b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.047 355.852H284.389c-6.18 0-11.191-5.01-11.191-11.191v-17.685c0-6.18 5.01-11.191 11.191-11.191h162.658c6.18 0 11.191 5.01 11.191 11.191v17.685c0 6.181-5.01 11.191-11.191 11.191z",
    style: {},
    fill: "#e49280",
    "data-original": "#e49280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.047 315.786h-39.069c6.18 0 11.19 5.01 11.19 11.191v17.685c0 6.18-5.01 11.191-11.19 11.191h39.069c6.18 0 11.191-5.01 11.191-11.191v-17.685c0-6.181-5.01-11.191-11.191-11.191z",
    style: {},
    fill: "#dd7f66",
    "data-original": "#dd7f66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.81 116.26-10.152-6.095a68.19 68.19 0 0 0 1.111-12.275 68.19 68.19 0 0 0-1.111-12.275l12.36-7.421c5.905-3.545 7.818-11.206 4.272-17.111L384.616 41.64c-3.545-5.905-11.206-7.817-17.111-4.272l-12.369 7.426a67.73 67.73 0 0 0-18.368-10.412V19.97c0-6.887-5.583-12.47-12.47-12.47h-22.679c-4.709 0-8.805 2.612-10.927 6.464 33.272 13.34 56.772 45.887 56.772 83.926s-23.5 70.586-56.772 83.926c2.122 3.852 6.219 6.464 10.927 6.464h22.679c6.887 0 12.471-5.583 12.471-12.47v-14.411a67.719 67.719 0 0 0 18.368-10.412l12.369 7.427c5.905 3.545 13.566 1.632 17.111-4.272l10.348-17.236c4.276-7.126 1.969-16.368-5.155-20.646z",
    style: {},
    fill: "#678d98",
    "data-original": "#678d98",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.81 116.26-10.152-6.095c.728-3.981 1.111-8.083 1.111-12.275s-.383-8.294-1.111-12.275l12.36-7.421c5.905-3.545 7.817-11.206 4.272-17.111L384.616 41.64c-3.545-5.905-11.206-7.818-17.111-4.272l-12.369 7.426a67.715 67.715 0 0 0-18.368-10.412V19.97c0-6.887-5.583-12.47-12.47-12.47h-22.679c-6.887 0-12.47 5.583-12.47 12.47v14.411a67.719 67.719 0 0 0-18.368 10.412l-12.369-7.427c-5.905-3.545-13.565-1.632-17.11 4.272l-11.674 19.444c-3.545 5.905-1.633 13.565 4.272 17.111l12.36 7.421c-.728 3.981-1.111 8.083-1.111 12.275s.383 8.294 1.111 12.275l-12.36 7.421c-5.905 3.545-7.817 11.206-4.272 17.111l11.674 19.444c3.545 5.905 11.206 7.817 17.111 4.272l12.369-7.426a67.715 67.715 0 0 0 18.368 10.412v14.411c0 6.887 5.583 12.47 12.47 12.47h22.679c6.887 0 12.47-5.583 12.47-12.47v-14.411a67.719 67.719 0 0 0 18.368-10.412l12.369 7.426c5.905 3.545 13.566 1.632 17.111-4.272l10.348-17.236c4.276-7.124 1.969-16.366-5.155-20.644z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.958,
    cy: 97.89,
    r: 34.505,
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.7 332.72 62.52 4.44c15.29 1.09 26.5 14.82 24.49 30.02l-8.54 109.77 13.38 16.19c3.74 4.53.52 11.36-5.35 11.36h-37.59c-7.86 0-14.07-6.67-13.5-14.51l6.73-99.9-39.8 6.33M96.27 317.81l21.92-67.47c4.62-14.23 19.51-22.42 34-18.71l35.86 9.2",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.57 315.79c.23-1.65.2-3.36-.11-5.1-1.41-7.94-8.33-13.66-16.29-13.66-.37 0-.74.02-1.11.04l-53.61 3.55-16.02-46.96c-3.4-9.96-14.23-15.28-24.2-11.88-7.92 2.71-12.91 10.11-12.91 18.05 0 2.04.33 4.11 1.02 6.15l16.1 47.18c5.32 15.59 20.8 25.35 37.17 23.42l51.59-6.07",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.688,
    cy: 170.608,
    rx: 33.413,
    ry: 33.406,
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    transform: "rotate(-89.192 171.681 170.608)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.238 504.5H74.211c-8.134 0-14.728-6.594-14.728-14.728v0c0-8.134 6.594-14.728 14.728-14.728h77.027c8.134 0 14.728 6.594 14.728 14.728v0c.001 8.134-6.593 14.728-14.728 14.728zM53.762 355.536v25.078c0 10.161 8.237 18.399 18.399 18.399h78.831c11.43 0 20.695-9.266 20.695-20.695v0c0-11.43-9.266-20.695-20.695-20.695h-47.71l-17.75-100.818a16.005 16.005 0 0 0-15.763-13.23h0c-8.84 0-16.006 7.166-16.006 16.006v60.846M112.725 399.013v76.03M447.047 355.852H284.389c-6.18 0-11.191-5.01-11.191-11.191v-17.685c0-6.18 5.01-11.191 11.191-11.191h162.658c6.18 0 11.191 5.01 11.191 11.191v17.685c0 6.181-5.01 11.191-11.191 11.191zM458.238 504.5v-8.125c0-8.459-6.858-15.317-15.317-15.317H322.886c-8.459 0-15.317 6.858-15.317 15.317v8.125M427.184 390.899v90.159h-28.058V355.852h28.058M359.324 280.916h0c-7.049-3.68-9.78-12.378-6.1-19.427l33.831-64.8c3.68-7.049 12.378-9.78 19.427-6.1h0c7.049 3.68 9.78 12.378 6.1 19.427l-33.831 64.8c-3.679 7.049-12.377 9.78-19.427 6.1z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.322 241.162 13.104 6.729a13.403 13.403 0 0 1 7.281 11.924v55.972M245.2 504.5h-37.59c-7.86 0-14.07-6.67-13.5-14.51l2.17-32.22h42.38l-1.49 19.18 13.38 16.19c3.74 4.53.52 11.36-5.35 11.36zM103.2 357.19l55.5-24.47 15.67-49.06M96.27 317.81l21.92-67.47c4.62-14.23 19.51-22.42 34-18.71l35.84 9.2h.02",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.006d9a2922d60a24f9de208edb3e76b0.svg";
export { ForwardRef as ReactComponent };